import { CustomField } from "@/backend/models/customFields/customField";
import { FileCustomField } from "@/backend/models/customFields/fileCustomField";
import { Parameter } from "@/backend/models/parameter";
import { useState } from "react";
import { FilePreviewModal } from "../files/FilePreviewModal";
import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { I18n } from "@/i18n/I18n";
import { ObjectCustomField } from "@/backend/models/customFields/objectCustomField";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";


export function ConfigValue(props: { currentField: CustomField, parameter: Parameter }) {
  const { currentField, parameter } = props;

  if(currentField instanceof FileCustomField) {
    return <FileValue customField={currentField} />;
  }

  if(currentField instanceof ObjectCustomField) {
    if(parameter.isChoice()) {
      return <span>{currentField.objectInstance.title}</span>;
    }
    
    return <span>{`${currentField.objectInstance.title} ${currentField.objectInstance.properties.map(property => `[${property.key}:${property.file?.fileName || property.value}]`).join(', ')}`}</span>;
  }

  return <span>{currentField.asString()}</span>;
}

function FileValue(props: { customField: FileCustomField }) {
  const { customField } = props;
  const [showPreview, setShowPreview] = useState(false);
  const downloadFileById = useGlobalStore(state => state.downloadFileById);

  const { file } = customField;

  if(!file) {
    return <span>{I18n.get('noFileUploaded')}</span>;
  }

  const handleFileOnClick = () => {
    if(file.isPreviewable()) {
      setShowPreview(true);
    } else {
      void downloadFileById(file);
    }
  };

  return (
    <>
      <button onClick={handleFileOnClick} key={file.id} style={{ background: 'none', border: 'none', padding: 0, textDecoration: 'underline', cursor: 'pointer', font: 'inherit', color: 'inherit' }}>{file.fileName}</button>
      {showPreview && <FilePreviewModal file={file} onHide={() => setShowPreview(false)} />}
    </>
  );
}

export function ConfigurationDetails(props: { parameters: Parameter[] }) {
  const { parameters } = props;

  return (
    <div className="config-details">
      {parameters.map((parameter, i) => (
        <div key={i} style={{ display: 'contents' }}>
          <div className="config-details-property">{parameter.title}</div>
          <div className="config-details-value">
          <span>
            {parameter.getFields().map((field, i) => (
              <span key={i}>
                <ConfigValue currentField={field} parameter={parameter} />
                {i < parameter.getFields().length - 1 && (
                  parameter.fieldType === CUSTOM_FIELD_TYPES.Object && !parameter.isChoice() ? <span>{'\n\n'}</span> : <span className="config-details-separator">{` | `}</span>
                )}
              </span>
            ))}
          </span>
          </div>
        </div>
      ))}
    </div>
  );
}
